import { FC } from 'react';
import ProPopover, { PopoverProps } from './popover';

export type IPopoverComponent = FC<
  PopoverProps & React.RefAttributes<HTMLElement>
>;

const TransPopover = ProPopover as IPopoverComponent;

export default TransPopover;
